module.exports = __webpack_public_path__ + "media/images/contact-decoration-0f941717a0caf99ae8592ea8d2107a92.png";